<template>
  <div :class="['residence-block block',{ show }]">
    <!--Блок разварачивания-->
    <div @click="blockToggle()"
         class="block-toggle-bar align-center justify-between">
      <div class="block-name align-center justify-center">
        <svg width="22px" height="15px" fill="var(--white-color)" fill-opacity="0.7">
          <use xlink:href="../../../assets/images/sprite.svg#hotel"></use>
        </svg>
        <span class="ml-8">{{ localizeList.accommodation }}</span>
      </div>
      <svg width="8px" height="12px" fill="var(--white-color)" class="angle-icon">
        <use xlink:href="../../../assets/images/sprite.svg#angle"></use>
      </svg>
    </div>
    <div v-for="(item, key) in residence"
         v-show="show"
         :key="key"
         class="hotel-info">
      <div class="hotel-name-feature">
        <div class="flex">
          <div class="hotel-name-wrap">
            <div class="flex">
                <h3 class="hotel-name">
                    <a v-if="isActiveHotelName(item)" @click.prevent="rightModalHotelInfo(item, key)"
                       :href="getHotelHref(item)"
                       class="nowrap">
                        {{ item.hotelName }}
                    </a>
                    <a v-else class="nowrap" style="cursor:default;">
                        {{ item.hotelName }}
                    </a>
                    {{ typeof item.hotelStars === "string" ? item.hotelStars : "" }}
                </h3>
              <div v-if="typeof item.hotelStars === 'number'" class="hotel-stars flex">
                <div v-for="(star) in item.hotelStars" :key="star">
                  <svg width="14px" height="14px" fill="var(--yellow-color)">
                    <use xlink:href="../../../assets/images/sprite.svg#star"></use>
                  </svg>
                </div>
              </div>
            </div>
            <div class="hotel-min-info">
              <p class="nowrap">{{ getHotelDateInfo(item) }}</p>
              <p class="nowrap">{{ getHotelTimeInfo(item) }}</p>
            </div>
          </div>
          <div class="features align-center flex-wrap">
            <div class="popover-link mr-6"
                 v-for="(icon, iconKey) in item.hotelFeatures"
                 :key="iconKey"
                 @mouseleave="hidePopover()"
                 @mouseenter="showPopover(icon.text, $event)">
              <img width="20px" height="20px" :src="icon.src"
                   class="hotel-type-icon"/>
            </div>
          </div>
        </div>
      </div>
      <div class="hotel-images-food">
          <div v-if="isActiveHotelName(item)" class="hotel-images">
              <div v-for="(img, imgKey) in item.hotelImages"
                   v-show="imgKey < 3"
                   @click="rightModalHotelInfo(item, key)"
                   :key="imgKey"
                   :style="{backgroundImage: `url('${img.replace('small160x90','medium')}')`}"
                   :class="['hotel-image',{'empty': img.includes('null')}]">
                  <div v-if="imgKey === 2 && item.hotelImages.length > 3"
                       class="more-image">
                      <p>{{ `+${item.hotelImages.length - 3} ${localizeList.photoUpper}` }}</p>
                  </div>
              </div>
          </div>
          <div v-else class="hotel-images">
              <div v-for="(img, imgKey) in item.hotelImages"
                   v-show="imgKey < 3"
                   :key="imgKey"
                   :style="{backgroundImage: `url('${img.replace('small160x90','medium')}')`}"
                   :class="['hotel-image',{'empty': img.includes('null')}]"
                   style="cursor:default;">
              </div>
          </div>
          <!-- Таблица питания-->
          <div class="food-table">
              <div class="thead" :ref="`foodTableHead${key}`">
                  <div class="td slider">
                      {{localizeList.accommodationFoodOption}}
                  </div>
                  <div v-for="(item2, key2) in item.foodHeader"
                       :key="key2"
                       :class="['td', {'justify-between': key2 === item.foodHeader.length-1}]">
                      <template v-if="item.foodHeaderAll.length > item.foodHeader.length && key2 === 0">
                          <div @click="foodSlideLeft(key)" class="slide slide-left mr-4">
                              <svg width="14px" height="14px" fill="var(--white-color)">
                                  <use xlink:href="../../../assets/images/sprite.svg#angle"></use>
                              </svg>
                          </div>
                      </template>
                      <div>{{ item2 }}</div>
                      <template v-if="item.foodHeaderAll.length > item.foodHeader.length && key2 === item.foodHeader.length-1">
                          <div @click="foodSlideRight(key)" class="slide slide-right">
                              <svg width="14px" height="14px" fill="var(--white-color)">
                                  <use xlink:href="../../../assets/images/sprite.svg#angle"></use>
                              </svg>
                          </div>
                      </template>
                  </div>
              </div>
              <div class="tbady">
                  <div v-for="(item2, key2) in item.foodItems"
                       :key="key2"
                       :ref="`foodTableRow${key}`"
                       class="td-row">
                      <div v-for="(item3, key3) in item2"
                           :key="`${key}-${key2}-${key3}`"
                           :class="['td',{'td-left': key3 === 0}, {'checked': checkIsActive(key, key2, key3, item3.value)}]">
                          <div v-if="item3.isEmpty">
                              –
                          </div>
                          <div v-else-if="key3 === 0">
                              {{ item3.text }}
                          </div>
                          <div v-else class="align-center justify-between w100">
                              <div class="flex-wrap">
                                  <radio-btn class="mr-4"
                                             :hide-radio="hideRadioBtn(item)"
                                             :value="checkIsActive(key, key2, key3, item3.value)"
                                             @change="setFood(key, key2, key3, item3)">
                                      <span v-if="checkIsActive(key, key2, key3, item3.value)">
                                          {{ localizeList.selected.toLowerCase() }}
                                      </span>
                                      <span v-else-if="roundFoodPrice(item3.text) !== 0">
                                          {{ getPlus(item3.text) }}{{ roundFoodPrice(item3.text) }} {{ tourRate }}
                                      </span>
                                  </radio-btn>
                                  <span v-if="item3.criticalInfo && item3.criticalInfo!='cancelWithNoPenalty'" class="red-text text-small text-400">
                                      {{ localizeList[item3.criticalInfo] }}
                                  </span>
                              </div>
                              <div class="align-center">
                                  <div class="popover-link"
                                       @mouseleave="hidePopover()"
                                       @mouseenter="showPopover(getQuotaText(item3.quota), $event)">
                                      <icon :name="getQuotaName(item3.quota)" width="16px" height="16px" fill="var(--white-color)" />
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div v-show="brutto.length && brutto[key] || bookingAdditionalInfo.length && bookingAdditionalInfo[key]"
           class="warning-block mt-6">
        <div v-show="brutto.length && brutto[key]" class="align-center">
          <icon @click.native="alertShow(key, outHotelCalculateData[key].find(x => x.AdditionalInfo) ? 5000 : 0)"
                class="mr-4 pointer"
                name="info" width="18" height="18" fill="var(--primary-color)" />
          <span v-html="brutto[key]" class="standard-text-small"></span>
        </div>
        <div v-if="bookingAdditionalInfo.length && bookingAdditionalInfo[key]">
          <div v-for="(item2, key2) in bookingAdditionalInfo[key]"
               :key="key2"
               class="additional-info mt-4">
            <div class="flex">
              <icon name="info" width="18" height="18" fill="var(--primary-color)" class="mr-4" />
              <div ref="infoText"
                   v-html="item2.Message"
                   :class="['info-text standard-text-small', {'open': infoShow[key2]}]">
              </div>
            </div>
            <div v-if="infoBtn[key2]"
                 @click="toggleInfoText(key2)"
                 :class="['more',{'open': infoShow[key2]}]">
              <span v-if="infoShow[key2]">{{localizeList.minimize}}</span>
              <span v-else>{{localizeList.more}}</span>
            </div>
          </div>
        </div>
      </div>
      
      <button v-show="hasMetapolicyInfo" class="important-info" @click="showPolicyInfoPopup = true" :disabled="!hasMetapolicyInfo">{{ localizeList.importantInfo }}</button>
      <policy-info-popup v-if="showPolicyInfoPopup" :MetapolicyExtraInfo="MetapolicyExtraInfo" @close="showPolicyInfoPopup = false" />

    </div>
  </div>
</template>

<script>
import policyInfoPopup from './policyInfoPopup.vue'
export default {
  name: "residence",
  components: { policyInfoPopup },
  data() {
    return {
      infoBtn: [],
      infoShow: [],
      leftTd: 0,
      table: 0,
      showPolicyInfoPopup: false,
    }
  },
  props: {
    residence: {
      type: Array,
      default: () => []
    },
    brutto: {
      type: Array,
      default: () => []
    },
    outHotelCalculateData: {
      type: Array,
      default: () => []
    },
    bookingAdditionalInfo: {
      type: Array,
      default: () => []
    },
    tourRate: {
      type: String,
      default: ""
    },
    show: {
      type: Boolean,
      default: true
    },
    columnCount: {
      type: Number,
      default: 3
    },
    MetapolicyExtraInfo: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    window.addEventListener("resize", this.resize)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize)
  },
  computed: {
    settings() {
        const settings = this.$store.getters['getSettings'];
        // settings.AutomaticLoadingResults = true;
        return settings;
    },
    hasMetapolicyInfo(){
      return this.MetapolicyExtraInfo ? !!Object.keys(this.MetapolicyExtraInfo).length : null;
    }
  },
  mounted() {
    this.leftTd = document.querySelector(".residence-block .td.slider");
    this.table = document.querySelector(".residence-block .food-table");

    this.slideToSelectedFood();
  },
  methods: {
    resize() {
      const tdMinWidth = 207;
      const count = Math.floor((this.table.offsetWidth - this.leftTd.offsetWidth) / tdMinWidth);

      if (this.columnCount !== count) {
        this.$emit("updateColumns", count)
      }
    },
    async slideToSelectedFood() {
      await this.$nextTick();

      this.residence.forEach((x, i) => {
        const colIndex = x.food[1];
        const maxCol = this.columnCount;
        const slideCount = colIndex - maxCol;

        if (slideCount > 0) {
          for (let j = 0; j < slideCount; j++) {
            this.foodSlideRight(i)
          }
        }
      })
    },
    hideRadioBtn(item) {
      return item.foodItems.length < 2 && item.foodItems[0].length < 3;
    },
    getCorrectDateOrTime(str, type = 'date') {
      let res = str.split('T');
      if (type === 'date') {
        res = res[0].split('-').reverse().join('.')
      } else {
        res = res[1].slice(0,5)
      }
      return res
    },
    getHotelDateInfo(item) {
      const count = item.allData.DurationInNight;
      const nightText = count >= 5 ? this.localizeList.nights : (count > 1 ? this.localizeList.night2 : this.localizeList.night);

      const hotelCity = item.hotelCity;
      const from = this.localizeList.from;
      const to = this.localizeList.to;
      const dateFrom = this.getCorrectDateOrTime(item.allData.BeginDateTime);
      const dateTo = this.getCorrectDateOrTime(item.allData.EndDateTime);

      return `${hotelCity}, ${from} ${dateFrom} ${to} ${dateTo}, ${count} ${nightText}.`
    },
    getHotelTimeInfo(item) {
      const checkInAt = this.localizeList.checkInAt;
      const checkOutBefore = this.localizeList.checkOutBefore;
      const checkInAtTime = item.hotelImagesDescription.CheckoutTimeFrom;
      const checkOutBeforeTime = item.hotelImagesDescription.CheckoutTimeTo;

      if (!checkInAtTime || !checkOutBeforeTime) return "";

      return `${checkInAt} ${checkInAtTime}, ${checkOutBefore} ${checkOutBeforeTime}.`
    },
    getHotelHref(item) {
      return item.http || null
    },
    getPlus(numb) {
      return numb <= 0 ? "" : "+"
    },
    checkIsActive(key, key1, key2, value) {
      let index = this.residence[key].sliderPosition;
      return this.residence[key].food[0] === key1 && this.residence[key].food[1] === key2 + index && this.residence[key].food[2] === value
    },
    setFood(key, key1, key2, item) {
      this.$emit("setFood", [key, key1, key2, item])
    },
    alertShow(key, time) {
      this.$emit("alertShow", [key, time])
    },
    blockToggle() {
      this.$emit("toggle", !this.show)
    },
    rightModalHotelInfo(item, key) {
        let viewRemoteHotels = this.settings.ViewRemoteHotels;
        if (viewRemoteHotels) {
            if (item.http !== null && item.http !== "") {
                window.open(item.http, '_blank');
            } else {
                this.$emit("rightModalHotelInfo", [item, key])
            }
        } else {
            this.$emit("rightModalHotelInfo", [item, key])
        }
    },
    isActiveHotelName(item) {
        let doNotShowEmptyHotelCards = this.settings.DoNotShowEmptyHotelCards;
        if (doNotShowEmptyHotelCards) {
            let viewRemoteHotels = this.settings.ViewRemoteHotels;
            if (viewRemoteHotels) {
                return item.hasImages || (item.http !== null && item.http !== "");
            }
            return item.hasImages;
        }
        return true;
    },
    foodSlideLeft(key) {
      this.$emit("foodSlideLeft", key)
    },
    foodSlideRight(key) {
      this.$emit("foodSlideRight", key)
    },
    getQuotaName(quota) {
      if (!quota) {
        return null
      }
      let res = null;
      if (quota.PlacesStatus === 2) {
        res = "not-aviailable"
      } else if (quota.PlacesStatus === 4) {
        res = "request"
      } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
        res = "less"
      } else {
        res = "aviailable"
      }
      return res
    },
    roundFoodPrice(price) {
      let res = 0;
      if (price < 0) {
        res = Math.abs(price);
        res = -Math.round(res);
      } else {
        res = Math.round(price);
      }
      return this.correctPrice(res)
    },
    correctPrice(val) {
      const isFloat = val % 1 !== 0;
      let res = new Intl.NumberFormat().format(val);

      if (res.includes(".") || !isFloat) {
        res = res.replace(/,/g, " ");
      } else {
        res = res.replace(/,/g, ".");
      }
      res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
      return res
    },
    getQuotaText(quota) {
      let res = null;
      if (quota.PlacesStatus === 2) {
        res = this.localizeList.quotaHasNoPlaces
      } else if (quota.PlacesStatus === 4) {
        res = this.localizeList.onRequest
      } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
        const placesLeft = quota.FreePlaces === 1 ? 'placesLeft1' : (quota.FreePlaces < 5 ? 'placesLeft2' : 'placesLeft3');
        res = this.localizeList[placesLeft].replace("{}", quota.FreePlaces);
      } else {
        res = this.localizeList.available
      }
      return res
    },
    showPopover(text, e) {
      let rect = e.target.getBoundingClientRect();
      let res = {
        x: rect.left + (rect.width / 2),
        y: rect.top,
        text: text,
        height: rect.height
      }
      this.$store.dispatch('A_SHOW_POPOVER', res);
    },
    toggleInfoText(key) {
      this.$set(this.infoShow, key, !this.infoShow[key]);
    },
    async setMoreBtn() {
      await this.$nextTick();
      if (!this.$refs.infoText) return;

      (this.$refs.infoText).forEach((x, i) => {
        if (x.offsetHeight < x.scrollHeight) {
          this.$set(this.infoBtn, i, true);
        }
      })
    },
    async setStyles() {
      await this.$nextTick();

      const tegUl = document.querySelectorAll(".info-text ul");
      const tegP = document.querySelectorAll(".info-text p");

      tegP.forEach(x => {
        x.style.margin = "0 0 10px";
      });

      tegUl.forEach(x => {
        x.style.margin = "0 0 10px";
        x.style.paddingInlineStart = "40px";
        x.style.listStyleType = "disc";
      });
    }
  },
  watch: {
    bookingAdditionalInfo(val) {
      if (val.length) {
        this.setMoreBtn();
        this.setStyles();
      }
    }
  }
}
</script>

<style scoped>
.important-info {
  cursor: pointer;
  margin: 10px;
  color: var(--primary-color);
  background: white;
  font-weight: 500;
  border: none;
  font-size: 16px;
}

.important-info:disabled {
  color: grey;
}

.block {
  background: var(--white-color);
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.11);
  border-radius: 4px;
  margin-bottom: 12px;
  transition: all .3s;
}

.block .block-toggle-bar {
  border-radius: 4px;
  background: var(--primary-color);
  padding: 12px 16px;
  cursor: pointer;
}

.block.show .block-toggle-bar {
  border-radius: 4px 4px 0 0;
}

.block .block-toggle-bar .block-name span {
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  color: var(--white-color);
}

.block .block-toggle-bar .angle-icon {
  transform: rotate(-90deg);
  transition: all .2s;
}

.block.show .block-toggle-bar .angle-icon {
  transform: rotate(90deg);
  transition: all .2s;
}

.block .hotel-info {
  padding: 20px 26px 28px;
}

.block .hotel-info .hotel-name-feature {
  display: flex;
}

.block .hotel-info .hotel-name-feature .hotel-name-wrap .hotel-name a,
.block .hotel-info .hotel-name-feature .hotel-name-wrap .hotel-name {
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  display: flex;
  align-items: center;
  text-decoration-line: underline;
  color: var(--primary-color);
  margin-right: 4px;
  cursor: pointer;
  transition: all .2s;
}

.block .hotel-info .hotel-name-feature .hotel-name-wrap .hotel-name:hover {
  color: #61b9f9;
}

.block .hotel-info .hotel-name-feature .hotel-name-wrap .hotel-stars {
  min-width: 64px
}

.block .hotel-info .hotel-name-feature .hotel-name-wrap .hotel-min-info {
  font-size: 14px;
  line-height: 16px;
  color: var(--dark-1-color);
  margin-top: 4px;
}

.block .hotel-info .hotel-name-feature .features {
  max-height: 22px;
  margin-left: 8px;
}

.block .change-btn {
  background: var(--primary-2-color);
  border: 1px solid #B2DBF8;
  box-sizing: border-box;
  border-radius: 20px;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #0094E9;
  padding: 10px 16px;
  transition: all .2s;
  outline: none;
}

.block .change-btn:hover {
  background: var(--primary-color);
  color: var(--white-color);
}

.block .hotel-images-food {
  margin-top: 12px;
}

.block .hotel-images-food .hotel-images {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1px;
  margin-bottom: 8px;
}

.block .hotel-images-food .hotel-images .hotel-image {
  position: relative;
  background-color: var(--lighten-4-color);
  background-size: 102%;
  background-repeat: no-repeat;
  background-position: 50%;
  height: 200px;
  cursor: pointer;
  transition: all .2s;
}
.block .hotel-images-food .hotel-images .hotel-image:hover {
  background-color: rgba(50, 50, 50, .4);
}

.block .hotel-images-food .hotel-images .hotel-image .more-image {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(50, 50, 50, .4);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all .2s;
}

.block .hotel-images-food .hotel-images .hotel-image .more-image:hover {
  background-color: rgba(50, 50, 50, .7);
}

.block .hotel-images-food .hotel-images .hotel-image .more-image p {
  font-weight: 500;
  font-size: 13px;
  line-height: 15px;
  color: var(--white-color);
  border: 1px solid rgba(255, 255, 255, .4);
  box-sizing: border-box;
  border-radius: 4px;
  padding: 12px 36px;
}

.delta {
  color: #1C88D6;
  font-size: 13px;
  font-weight: bold;
  white-space: nowrap;
  position: absolute;
  top: -16px;
  left: 11px;
}

.delta.plus {
  left: 8px;
}

.food-table .thead {
  display: flex;
}

.food-table .thead .td {
  flex: 1;
}

.food-table .thead .slider.td {
  min-width: 230px;
  flex: 0;
  display: flex;
  align-items: center;
  padding: 10px;
  line-height: 16px;
}

.food-table .thead .slide {
  width: 25px;
  min-width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--primary-color);
  border-radius: 50%;
  cursor: pointer;
  transition: all .2s;
}

.food-table .thead .slide:hover {
  background-color: #2984c6;
}

.food-table .thead .slide-right {
  margin-left: 12px;
  transform: rotate(180deg)
}

.food-table .thead .td,
.food-table .tbady .td {
  display: flex;
  align-items: center;
  border: 1px solid var(--lighten-4-color);
  border-right: none;
  box-sizing: border-box;
  font-weight: bold;
  font-size: 15px;
  line-height: 29px;
  color: var(--dark-1-color);
  padding: 14px 10px;
}

.food-table .thead .td:last-child {
  border-right: 1px solid var(--lighten-4-color);
}

.food-table .tbady .td-row {
  display: flex;
}

.food-table .tbady .td-row .td {
  flex: 1;
}

.food-table .tbady .td-row .td-left {
  min-width: 230px;
  flex: 0;
}

.food-table .tbady .td {
  border-top: none;
  line-height: 19px;
  color: #313131;
}

.food-table .tbady .td.checked {
  color: var(--primary-color);
}

.food-table .tbady .td:last-child {
  border-right: 1px solid var(--lighten-4-color);
}

.food-table .tbady .td-left {
  padding: 14px 20px;
  text-align: left;
  color: var(--dark-1-color);
}

.food-table .tbady .td-row .td:not(:first-child).checked {
  background-color: var(--primary-2-color);
}

.additional-info {
  position: relative;
}

.additional-info .more {
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: var(--white-color);
  font-size: 13px;
  line-height: 16px;
  text-decoration-line: underline;
  color: var(--primary-color);
  padding-left: 10px;
  cursor: pointer;
}

.additional-info .more.open {
  position: unset;
  padding-left: 26px;
}


.info-text {
  transition: .2s all;
  padding-top: 2px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.info-text.open {
  -webkit-line-clamp: unset;
}
</style>
